import { Component, OnInit } from '@angular/core';
import {LanguageService} from '../service/language.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class AboutComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(private translate: TranslateService, private _language: LanguageService ) {
    this._language.current_lang.subscribe(lang => {
    if (lang === 0 ) {
      translate.use('ro');
    } else {
      translate.use('en');
    }
  });
  }

  ngOnInit(): void {
  }

}
